import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PartnerService } from '../../../../../../services/partner.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddEditFranchiseComponent } from "src/app/components/modals/add-edit-franchise/add-edit-franchise.component";
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-franchise',
  templateUrl: './franchise.component.html',
  styleUrls: ['./franchise.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MessageService]
})
export class FranchiseComponent implements OnInit {

  partners: any = [];
  partnerParents: any = [];
  selectedPartnerParentId: any;
  selectedPartnersIds: any;

  constructor(private partnerService: PartnerService,
    public messageService: MessageService,
    public modalService: NgbModal)     { 

    }

  ngOnInit(){
    this.getPartnerParents();
    this.getPartners();
  }

  getPartnerParents(){
    this.partnerService.getPartnerParents().subscribe(partnerParents => {
      this.partnerParents = partnerParents;
      //this.partnerParents.forEach(x => { x.value = x.id, x.label = x.name; x.partnersLinked = x.partnersLinked });
      this.partnerParents = this.partnerParents.map((x:any)=>{return {...x, value : x.id, label : x.name, partnersLinked : x.partnersLinked}});
      console.log(this.partnerParents);
    });
  }

  getPartners() {
    this.partnerService.getPartnersV2(1, 100000, "").subscribe(partners => {
      this.partners = partners;
      this.partners.forEach(x => { x.label = x.name; x.value = x.id; x.code = x.id, x.status = this.getStatus(x.statusID) });
    });
  }

  getStatus(ID) {
    switch (ID) {
      case 1: return "Trial"; break;
      case 2: return "Expired"; break;
      case 3: return "Payment Missed"; break;
      case 4: return "Card Expired"; break;
      case 20: return "Cancellation In Progress"; break;
      case 21: return "Cancelled"; break;
      case 50: return "Active"; break;
    }
    return "Unknown";
  }

  selectedFranchiseChange() {    
    let getFranchiseDetails = this.partnerParents.find(x => x.id == this.selectedPartnerParentId);
    this.selectedPartnersIds = [];
    if(getFranchiseDetails){
      this.selectedPartnersIds = getFranchiseDetails.partnersLinked;
    }
  }

  franchiseLink(){
    this.partnerService.postLinkFranchiseToStores(this.selectedPartnerParentId, this.selectedPartnersIds).subscribe(res => {
      //Update item without page refresh
      let getFranchiseDetails = this.partnerParents.find(x => x.id == this.selectedPartnerParentId);
      getFranchiseDetails.partnersLinked = this.selectedPartnersIds;

      this.selectedPartnerParentId = null;
      this.selectedPartnersIds = [];

      this.messageService.add({detail:"Franchise data has been saved",});
    });
  }

  newFranchise() {    
    const modalRef = this.modalService.open(AddEditFranchiseComponent, {
      size: "lg",
      backdrop: "static",
      windowClass: "user-modal",
    });
    modalRef.componentInstance.franchiseId = null;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.partnerParents.push({ 
        value: receivedEntry.Id, 
        id: receivedEntry.Id,
        label: receivedEntry.name,
        name: receivedEntry.name,
        partnersLinked: []
      });
    });
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.result.then(
      (result) => {
        console.log('created');
      },
      (onrejected) => {
        console.log(onrejected);
      }
    );
  }

  editFranchise() {   
    const modalRef = this.modalService.open(AddEditFranchiseComponent, {
      size: "lg",
      backdrop: "static",
      windowClass: "user-modal",
    });
    modalRef.componentInstance.franchiseId = this.selectedPartnerParentId;    
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      //Update existing value in list
      let getFranchiseDetails = this.partnerParents.find(x => x.id == receivedEntry.Id);
      getFranchiseDetails.name = receivedEntry.name;
      getFranchiseDetails.label = receivedEntry.name;
    });    
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.result.then(
      (result) => {
        console.log(result);
      },
      (onrejected) => {
        console.log(onrejected);
      }
    );
  }


}
